import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const reorderVariants = api(async function reorderVariants({ scenarioId, variantIds }) {
    return mutate(
        gql`
            mutation ReorderVariants($scenarioId: String!, $variantIds: [String!]!) {
                reorderVariants(scenarioId: $scenarioId, variantIds: $variantIds)
            }
        `,
        { scenarioId, variantIds },
        { returns: "reorderVariants" }
    )
})
